import { useQuery } from '@tanstack/react-query';
import logoCaetech from '../assets/caetech.png';
import { api } from '../lib/api.ts';
import './marca.css';

/* A marca da clínica em um lugar só. Quando ela troca de logo, troca em todas
   as telas — e enquanto não houver logo, o nome em texto ocupa o lugar, para
   nenhuma tela ficar com um buraco. */

export function useClinica() {
  return useQuery({
    queryKey: ['clinica-publica'],
    queryFn: ({ signal }) =>
      api.get<{ nome: string; endereco: string; telefone: string; temLogo: boolean }>(
        '/publico/clinica',
        signal,
      ),
    staleTime: 10 * 60_000,
    retry: false,
  });
}

export function Marca({
  tamanho = 'md',
  subtitulo,
}: {
  tamanho?: 'sm' | 'md' | 'lg';
  subtitulo?: string;
}) {
  const clinica = useClinica();
  const nome = clinica.data?.nome ?? 'Centro Médico';

  return (
    <div className={`marca marca--${tamanho}`}>
      {clinica.data?.temLogo ? (
        // alt com o nome da clínica: em leitor de tela e quando a imagem falha,
        // continua dizendo de quem é o sistema.
        <img className="marca__logo" src="/api/publico/logo" alt={nome} />
      ) : (
        <span className="marca__nome">{nome}</span>
      )}
      {subtitulo && <span className="marca__sub">{subtitulo}</span>}
    </div>
  );
}

/** Crédito do fabricante. Discreto de propósito: o sistema é da clínica, quem
 *  o fez assina embaixo.
 *
 *  Abre em aba nova, com `rel` completo: a clínica pode estar no meio de um
 *  cadastro, e trocar a página debaixo do pé de quem clicou sem querer faria
 *  perder o que estava digitado. */
export function Caetech({ className = '' }: { className?: string }) {
  return (
    <a
      className={`caetech ${className}`}
      href="https://caetech.com.br/"
      target="_blank"
      rel="noopener noreferrer"
      title="Caetech — caetech.com.br"
    >
      Um produto
      <img className="caetech__logo" src={logoCaetech} alt="Caetech" />
    </a>
  );
}
